import styled from '@emotion/styled'
import React from 'react'

const P = styled.p<{ isBold: number; color?: string }>`
  color: ${(props) => (props.color ? props.color : '#F9F9FB')};
  font-size: 14px;
  font-weight: ${(props) => (props.isBold ? '400' : '500')};
  line-height: 160%;
`

const MinimalText = ({
  text = '',
  isBold = 0,
  color = '',
}: {
  text: string
  isBold?: 0 | 1
  color?: string
}) => {
  return (
    <P isBold={isBold} color={color}>
      {text}
    </P>
  )
}

export default MinimalText
